var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 110,
    height: 94,
    viewBox: "0 0 110 94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.073,
    y2: 0.933,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6c9efc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#293462"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Icon_material-folder",
    x: 0,
    y: 0,
    width: 110,
    height: 94,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#293462",
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_21474",
    x: 29.727,
    y: 16.57,
    width: 40.546,
    height: 69.325,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -5,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#293462",
    floodOpacity: 0.502
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2605",
    "data-name": "Group 2605",
    transform: "translate(-918 -477.998)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 918, 478)",
    filter: "url(#Icon_material-folder)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-folder-2",
    "data-name": "Icon material-folder",
    d: "M35,6H11a7.989,7.989,0,0,0-7.96,8L3,62a8.024,8.024,0,0,0,8,8H75a8.024,8.024,0,0,0,8-8V22a8.024,8.024,0,0,0-8-8H43Z",
    transform: "translate(12 4)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 918, 478)",
    filter: "url(#Path_21474)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21474-2",
    "data-name": "Path 21474",
    d: "M10.487,16.075C10.083,5.695,5.971,0,5.3,0H5.247C4.575,0,.463,5.695.059,16.075S1.433,34.653,2.553,37.132c.83,1.839,1.147,2.193,1.864,2.193s.675-.433.675-.751,0-.83.179-.83h0c.179,0,.179.513.179.83s-.046.751.675.751,1.031-.354,1.864-2.193c1.12-2.479,2.9-10.676,2.494-21.057M7.042,31.464H4.278a.8.8,0,0,1-.8-.793V15.83a.01.01,0,0,1,0-.008.662.662,0,0,1,.814-.605c.3.061.595.127.889.206a4.735,4.735,0,0,1,2.164,1.15,1.758,1.758,0,0,1,.49,1.245c0,2.611.011,12.854.011,12.854a.8.8,0,0,1-.8.793m.97-17.069a3.07,3.07,0,0,0-1.958-1.409,13.5,13.5,0,0,1-2.3-.671,2.128,2.128,0,0,1-1.238-1.9A2.372,2.372,0,0,1,5.06,9.376a3.729,3.729,0,0,1,2.352,1.913,5.653,5.653,0,0,1,.6,3.105",
    transform: "translate(49.73 26.57)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadedIcon);
export default __webpack_public_path__ + "static/media/UploadedIcon.6a9089b83527ded8268e3258fd1d26d8.svg";
export { ForwardRef as ReactComponent };